interface PartiesSingleValueTemplateProps {
  isExpanded: boolean
  title: string
  value: string
  rowClassname?: string
  titleClassname?: string
  valueClassname?: string
}

const PartiesSingleValueTemplate = (props: PartiesSingleValueTemplateProps) => {
  return (
    <div className={`${props.rowClassname}`}>
      <div className={props.titleClassname}>
        <span>{props.title}</span>
      </div>
      <div className={props.valueClassname}>
        <span>{props.value}</span>
      </div>
    </div>
  )
}

export default PartiesSingleValueTemplate
